import React, { FC, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import Appeal from 'shared/components/Appeal/DefaultRenderer';
import OnboardingContentContainer from 'shared/components/OnboardingContentContainer';
import RecoveryForm from 'pages/RecoveryPassword/RecoveryForm';
import RecoveryCongrats from 'pages/RecoveryPassword/RecoveryCongrats';
import ResponseFailure from 'shared/components/ResponseFailure';
import { urls } from 'core/appUrls';
import { parseResetTokenFromSearch } from 'core/passwordRecovery';
import styles from 'pages/Organization/RecoveryPassword/RecoveryPassword.module.scss';

const SuperAdminResetPassword: FC = () => {
	const [isRecoverySuccess, setIsRecoverySuccess] = useState(false);
	const [responseError, setResponseError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const location = useLocation();
	const history = useHistory();

	const resetToken = useMemo(() => parseResetTokenFromSearch(location.search), [location.search]);

	useEffect(() => {
		if (!resetToken) {
			history.replace(urls.recoveryPassword);
		}
	}, [history, resetToken]);

	if (!resetToken) {
		return null;
	}

	if (responseError) {
		return (
			<OnboardingContentContainer>
				<ResponseFailure
					message={errorMessage}
					buttonTitle="Back to login"
					buttonClickHandler={() => history.push(urls.loginSuperAdmin)}
				/>
			</OnboardingContentContainer>
		);
	}

	return (
		<OnboardingContentContainer>
			<div className={styles.content}>
				<Appeal styleCongrats={isRecoverySuccess} stylePensive={!isRecoverySuccess}>
					{isRecoverySuccess ? (
						<RecoveryCongrats
							title="Your password was successfully changed."
							isRecoverySuccess={isRecoverySuccess}
						/>
					) : (
						<RecoveryForm
							resetToken={resetToken}
							setIsRecoverySuccess={setIsRecoverySuccess}
							setResponseError={setResponseError}
							setErrorMessage={setErrorMessage}
						/>
					)}
				</Appeal>
			</div>
		</OnboardingContentContainer>
	);
};

export default SuperAdminResetPassword;
